unable to read source [project]/workspace/frontend/src/core/DOMEvent.ts